import style from './home.module.css';
import logo from '../../assets/logo.png';
import grou from '../../assets/BANNERGROU.jpg';
import napole from '../../assets/BANNERNAPOLE.jpg';
import pitaia from '../../assets/BANNERPITAIA.jpg';

import cozinha from '../../assets/Cozinha.png';
import banheiro from '../../assets/Banheiro.png';
import lavanderia from '../../assets/Lavanderia.png';
import nicho from '../../assets/Nichos.png';
import cuba from '../../assets/Cubas.png';
import espelho from '../../assets/Espelhos e espelheiras.png';

import { ImExit } from 'react-icons/im';

import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';

const images = [
    grou,
    napole,
    pitaia
]




function Home() {

    const navigate = useNavigate();
    const [currentIndex, setCurrentIndex] = useState(0);

    function OpenMenu(wcodpai, wtipfil) {

        //navigate('/catalogo/menu', { state: { codcla: wcodpai, tipfil: wtipfil } });
    }

    const goToSlide = (index) => {
        setCurrentIndex(index);
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, 5000);

        return () => clearInterval(interval); // limpa ao desmontar
    })

    return (
        <div className={style.content}>
            <div className={style.banner}>
                <div className={style.menuhome}>
                    <div className={style.menuhomecontent}>
                        <img src={logo}></img>
                        <a onClick={() => OpenMenu(3, '')}>COZINHA</a>
                        <a onClick={() => OpenMenu(6, '')}>BANHEIRO</a>
                        <a onClick={() => OpenMenu(206, '')}>LAVANDERIA</a>
                        <a onClick={() => OpenMenu(298, '')}>CUBAS</a>
                        <a onClick={() => OpenMenu(299, '')}>NICHOS</a>
                        <a onClick={() => OpenMenu(300, '')}>ESPELHOS / ESPELHEIRAS</a>
                        <ImExit className={style.iconmenu} onClick={() => navigate('/main')} />
                    </div>
                </div>


            </div>

            <div className={style.bannerimages}>
                <img src={images[currentIndex]}
                    alt="Carrossel"
                    style={{

                        objectFit: "contain",
                        borderRadius: "3px",
                        transition: "opacity 0.5s ease"


                    }} ></img>

                <div
                    style={{
                        position: "absolute",
                        bottom: "5px",
                        left: "50%",
                        transform: "translateX(-50%)",
                        display: "flex",
                        gap: "8px"
                    }}
                >
                    {images.map((_, index) => (
                        <span
                            key={index}
                            onClick={() => goToSlide(index)}
                            style={{
                                width: "12px",
                                height: "12px",
                                borderRadius: "50%",
                                background: currentIndex === index ? "rgba(0, 0, 0, 0.5)" : "rgba(102, 102, 102, 0.5)",
                                cursor: "pointer"
                            }}
                        ></span>
                    ))}
                </div>

            </div>

            <div className={style.categorias}>
               <img src={cozinha}/>
               <img src={banheiro}/>
               <img src={lavanderia}/>

               <img src={cuba}/>
               <img src={nicho}/>
               <img src={espelho}/>

            </div>


            <div className={style.rodape}>
                <p>Todos os direitos reservados COZIMAX MOVEIS MIRASSOL LTDA  - 2025</p>
            </div>
        </div>
    )
}



export default Home;